import { Component, OnInit } from '@angular/core';
import { ROUTES } from 'src/app/constants/Routes';


@Component({
  selector: 'app-babelfish',
  templateUrl: './babelfish.component.html',
  styleUrls: ['./babelfish.component.scss'],
  standalone: false
})
export class BabelfishComponent implements OnInit {
  Routes = ROUTES;
  activeSection = 'overview';

  sections = [
    { id: 'overview', label: 'Overview', icon: 'bx-layer' },
    { id: 'capabilities', label: 'Capabilities', icon: 'bx-chip' },
    { id: 'components', label: 'Components', icon: 'bx-cube-alt' },
    { id: 'control', label: 'Command & Control', icon: 'bx-terminal' },
  ];

  capabilities = [
    'Device-Type as a Service model with independent services per device type.',
    'End-to-end packet handling: reception, validation, parsing, normalization, processing, and routing.',
    'Plug-and-play integration with Kafka, MongoDB, and microservices architectures.',
    'Fault isolation and horizontal scaling at device-type level.',
    'Dedicated port assignment per device type for reliability and performance isolation.',
  ];

  components = [
    {
      title: 'Device Receiver',
      icon: 'bx-download',
      desc: 'Receives device packets, validates structure and integrity, filters invalid data, and converts valid packets to a common internal format.'
    },
    {
      title: 'Data Parser',
      icon: 'bx-code-alt',
      desc: 'Routes packets by packet type and processes location, authentication, heartbeat, and status payloads into structured records.'
    },
    {
      title: 'Dedicated Port Assignment',
      icon: 'bx-network-chart',
      desc: 'Each device type runs on a dedicated network port for isolation, performance, and independent scaling without interference.'
    },
  ];

  commandControl = [
    'Remote device control from cloud to connected devices.',
    'Real-time acknowledgement for delivery and execution tracking.',
    'Controlled execution only for online and authorized devices.',
    'Audit logging for compliance and diagnostics.',
  ];

  supportedCommands = [
    { label: 'Remote Immobilization', desc: 'Remotely disable a vehicle or device in real time.' },
    { label: 'Device Identification', desc: 'Trigger identification handshake from cloud to device.' },
    { label: 'Server Config Update', desc: 'Push updated server configuration parameters to the device.' },
    { label: 'Network Credential Update', desc: 'Update network access credentials on the device over the air.' },
  ];

  ngOnInit() {}


  scrollTo(sectionId: string) {
    const el = document.getElementById(sectionId);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.activeSection = sectionId;
  }

  private setupIntersectionObserver() {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) this.activeSection = entry.target.id;
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    this.sections.forEach(s => {
      const el = document.getElementById(s.id);
      if (el) observer.observe(el);
    });
  }
}
